
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/price-funeral/[code]",
      function () {
        return require("private-next-pages/price-funeral/[code]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/price-funeral/[code]"])
      });
    }
  